exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copy[data-v-26dd935f] {\n  position: absolute;\n  right: 10vh;\n  top: 20px;\n}\n", ""]);

// exports
